import React from 'react';
import classNames from 'classnames';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import Button from './Button.js';
import 'wix-rich-content-common';
import '../consts.js';

var css_248z = ".L8fzi,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.N8ugf{display:flex;font-family:inherit;justify-content:space-between;position:relative}[dir] .N8ugf{border-bottom:1px solid #ededed;padding:16px}.N8ugf.p5hGs{align-items:center;box-sizing:border-box;flex-direction:row-reverse;height:50px;position:absolute;top:0;width:100%;z-index:13}[dir] .N8ugf.p5hGs{background-color:#fff;padding:0 16px}[dir=ltr] .N8ugf.p5hGs{left:0}[dir=rtl] .N8ugf.p5hGs{right:0}.N8ugf.p5hGs *,.N8ugf.p5hGs :after,.N8ugf.p5hGs :before{box-sizing:inherit}.N8ugf.p5hGs input{box-sizing:border-box}.N8ugf .CVjzT{align-self:center;color:#646464;font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:16px;font-weight:400}";
var styles = {"fontElementMap":"L8fzi","setting_mobile_header":"N8ugf","setting_mobile_header_newUi":"p5hGs","setting_mobile_header_title":"CVjzT"};
styleInject(css_248z);

const SettingsMobileHeader = ({
  theme,
  onSave,
  onCancel,
  saveLabel,
  cancelLabel,
  title,
  t,
  children,
  useNewSettingsUi,
  showSaveBtn = true
}) => {
  const saveText = saveLabel || t("SettingsPanelFooter_Save");
  const cancelText = cancelLabel || t("SettingsPanelFooter_Cancel");
  const buttonsDataHook = { save: "actionButtonSave", cancel: "actionButtonCancel" };
  const renderButton = (text, dataHook, onClick, showBtn = true) => /* @__PURE__ */ React.createElement(
    Button,
    {
      ariaLabel: text,
      theme,
      isMobile: true,
      dataHook,
      onClick,
      style: !showBtn ? { visibility: "hidden" } : {}
    },
    text
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.setting_mobile_header, {
        [styles.setting_mobile_header_newUi]: useNewSettingsUi
      })
    },
    renderButton(saveText, buttonsDataHook.save, onSave, showSaveBtn),
    /* @__PURE__ */ React.createElement(React.Fragment, null, title && /* @__PURE__ */ React.createElement("div", { className: styles.setting_mobile_header_title }, title), children),
    renderButton(cancelText, buttonsDataHook.cancel, onCancel)
  );
};
var SettingsMobileHeader$1 = SettingsMobileHeader;

export { SettingsMobileHeader$1 as default };
//# sourceMappingURL=SettingsMobileHeader.js.map
